import config from 'config';

import { AskAutoResponse } from '../types';

export class AskAssistantError extends Error {}

interface AskParams {
    question: string;
    token?: string;
    locale?: string;
}

/** Server-side routed answer (tries SQL, falls back to RAG) — the only mode the UI offers. */
export async function askAssistantAuto({ question, token, locale }: AskParams): Promise<AskAutoResponse> {
    const response = await fetch(`${config.api.base}${config.api.askAuto}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
            ...(locale && { 'Accept-Language': locale }),
        },
        body: JSON.stringify({ question }),
    });

    if (!response.ok) {
        throw new AskAssistantError(`Failed to fetch assistant answer (status ${response.status})`);
    }

    return response.json();
}
